/** Moves one layer of a stack, as a drag in a layer list does */
export function moveLayer<T>(layers: T[], from: number, to: number): T[] {
	const next = [...layers];
	const [layer] = next.splice(from, 1);
	if (layer !== undefined) next.splice(to, 0, layer);
	return next;
}
